import {Error, Response} from "../vs-standard-form.model";
import {ERROR_MESSAGES} from "@src/workflows/vs-standard-form/vs-standard-form.constant";

export const shouldRedirectOnError = (response: Response, error: Error) => {
  return error && response?.data?.redirect && error?.message;
}

export const redirectUrlSafe = (url: string) => {
  const newWindow = window.open(null, '_self');
  newWindow.opener = null;
  newWindow.location = url;
}

// START GENAI@CHATGPT4
export const redirectOnRedirectErrorResponse = (response: Response, error: Error) => {
  const shouldRedirect = shouldRedirectOnError(response, error);
  const redirectUrl = response?.redirectUrl || response?.message ;

  if (shouldRedirect) {
    redirectUrlSafe(error?.message);
  } else if (response?.redirect) {
    redirectUrlSafe(redirectUrl);
  }
}
// END GENAI@CHATGPT4

export const handleErrorResponse = (response: Response, genericErrorMessage: string) => {
  const error = response?.errors && response?.errors[0];
  redirectOnRedirectErrorResponse(response, error);
  return updateErrorMessagesAndCode(response, error, genericErrorMessage);
}

// START GENAI@CHATGPT4
export const updateErrorMessagesAndCode = (response: Response, error: Error, genericErrorMessage: string) => {
  const errorResponse = {
    apiErrorMessages: genericErrorMessage,
    errorCode: error?.code?.toString() || response?.code?.toString() || null
  }
  // If there's an error message, update the error message
  if (error?.message) {
    errorResponse.apiErrorMessages = error.message;
    //sentosa golf monthly exceeded count
    if (error.message === 'MONTHLY_COUNT_EXCEED') {
      errorResponse.apiErrorMessages = ERROR_MESSAGES.MONTHLY_COUNT_EXCEED;
    }
  }
  // If the response was not successful, update the error message and code
  else if (response && !response?.success && response?.message) {
    errorResponse.apiErrorMessages = response.message;
  }
  // If there's still no error code, but there's one in the response data, update the error code
  if (!errorResponse?.errorCode && response?.data?.code) {
    errorResponse.errorCode = response.data.code.toString();
  }
  return errorResponse;
}
// END GENAI@CHATGPT4
